import React from 'react'

import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import SubscriptionForm from '@toasttab/otl/src/components/Form/SubscriptionForm/SubscriptionForm'
import classNames from 'classnames'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'

const SubscribeCTA = ({ formCategories }: any) => {
  const { t } = useI18next()
  const formCategory = formCategories.filter(
    (n: { title: string }) => n.title == 'Email Only'
  )[0]

  const subscribeClasses = classNames({
    'ds-grid rounded-lg shadow-lg w-full min-h-[258px] mb-8 lg:relative before:relative before:rounded-l-none\
     before:rounded-t-lg md:before:rounded-tr-none md:before:rounded-l-lg \
     before:w-full md:before:w-[235px] lg:before:w-[350px] before:h-[258px] before:bg-cover md:before:bg-auto \
     before:col-[1_/_-1] md:before:!col-auto before:bg-no-repeat before:bg-[length:100%] before:bg-img-otl-subscribe-cta':
      true
  })

  return (
    <section className='ds-wrapper ds-container'>
      <div className={subscribeClasses}>
        <div className='col-span-4 md:col-span-5 lg:col-span-10 w-full mt-0 md:mt-8 p-8 md:p-0 md:pr-6 lg:pr-0 text-left order-none sm:order-none'>
          <Typography
            variation='h3'
            as='h3'
            classes='mb-4 text-default text-[34px] leading-[34px] font-gliko'
            allowHtml={false}
          >
            {t('Subscribe to On the Line')}
          </Typography>
          <Typography
            as='p'
            classes='mb-4 text-default text-lg leading-[24px]'
            allowHtml={false}
          >
            {t(
              'Sign up to get industry intel, advice, tools, and honest takes from real people tackling their restaurants’ greatest challenges.'
            )}
          </Typography>
          <div className='lg:pt-4'>
            <SubscriptionForm
              addToSidebar={false}
              formCategory={formCategory}
              showPrivacyStatement
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default SubscribeCTA
